import {getIsProductionAppEnv} from '../../../utils/environment'

/**
 * Unified logic for determining if brand/theme overrides should be allowed.
 * Works in non-production environments OR on demo sites.
 * @param environment - The current application environment
 * @param hostname - The hostname to check for demo sites
 * @returns boolean - Whether overrides should be allowed
 */
export const shouldAllowOverrides = (
  environment: string,
  hostname: string
): boolean => {
  const envIsProduction = getIsProductionAppEnv(environment)

  const siteIsDemo = hostname.split('.').some(part => part.includes('demo'))

  return !envIsProduction || siteIsDemo
}
